@let navigationFlags = model.appNavigationFlags$();
@let alertNotificationEnabled = model.alertNotificationEnabled$();
@let enableNavigation = navigationFlags.enableNavigation$();
@let showNavigation = navigationFlags.showNavigation$();
@let mobileNavigation = navigationFlags.mobileNavigation$();
@let pinnedNavigation = navigationFlags.pinned$() && !navigationFlags.disablePinning$();
@let hoveredNavigation = navigationFlags.hovered$();
@let miniNavigation = showNavigation && !pinnedNavigation && !mobileNavigation;
@let fullNavigation = showNavigation && pinnedNavigation && !mobileNavigation;

<div *ngIf="model.showProgressBar$()" class="link-progress-bar-container">
  <mat-progress-bar mode="determinate" [value]="model.progressValue$()"></mat-progress-bar>
</div>

<div class="link-alert-container" *ngIf="model.userLoggedIn$() && alertNotificationEnabled" [class.mobile]="mobileNavigation">
  <link-notification-list></link-notification-list>
</div>

<div id="link-core-view" class="link-core-view">
  <div class="content-section"
       *ngIf="model.translationLoaded$() || !model.translationEnabled$()"
       [class.content-section-with-mini-navigation]="enableNavigation && miniNavigation"
       [class.content-section-with-full-navigation]="enableNavigation && fullNavigation"
       [class.content-section-with-mobile-navigation]="enableNavigation && mobileNavigation">
    <router-outlet></router-outlet>
  </div>
</div>

<div class="mobile-app-header-section" *ngIf="model.userLoggedIn$() && enableNavigation && mobileNavigation">
  <link-mobile-app-header data-link-ga-node="MobileAppHeader" (onActivation)="mobileNavigationActivation()"></link-mobile-app-header>
</div>

<div class="navigation-section"
     *ngIf="model.userLoggedIn$() && enableNavigation"
     [style.visibility]="showNavigation ? 'visible' : 'hidden'"
     [class.navigation-section-with-full-navigation]="pinnedNavigation || hoveredNavigation || mobileNavigation"
     [class.mobile]="mobileNavigation"
     (clickOutside)="navigationMouseLeave()"
     (mouseenter)="navigationMouseEnter()"
     (mouseleave)="navigationMouseLeave()">
  <link-app-navigation-view [appNavigationFlags]="model.appNavigationFlags$()"
                            (onPinToggle)="navigationPinToggle()"
                            (onDeactivation)="mobileNavigationDeactivation()">

  </link-app-navigation-view>
</div>

<p-toast *ngIf="alertNotificationEnabled" key="alert" [position]="mobileNavigation ? 'bottom-center' : 'top-right'">
  <ng-template pTemplate="headless" let-message let-closeFn="closeFn">
    <link-alert-instance [mode]="'toast'"
                         [alertInstance]="message.data"
                         (onClose)="closeFn($event)"
                         (onSelect)="closeFn($event)">
    </link-alert-instance>
  </ng-template>
</p-toast>

<p-toast key="message" [position]="mobileNavigation ? 'bottom-center' : 'bottom-left'" />

<p-toast key="app-error-status-message" [position]="mobileNavigation ? 'bottom-center' : 'bottom-right'" >
  <ng-template *ngIf="model.userLoggedIn$()" pTemplate="headless" let-message>
    <div class="app-error-status-toast-message">
      {{message.summary | translate}}
    </div>
  </ng-template>
</p-toast>

<p-toast key="app-auto-update-info-status-message" [position]="mobileNavigation ? 'bottom-center' : 'bottom-right'" >
  <ng-template *ngIf="model.userLoggedIn$()" pTemplate="headless" let-message>
    <div class="app-auto-update-info-status-toast-message">
      <div class="auto-update-main-message">
        {{message.summary | translate}}
      </div>
      <div class="auto-update-count-down-message">
        {{model.autoUpdateCountDownMessage$()}}
      </div>
      <div class="auto-update-actions">
        <button mat-flat-button (click)="updateNowClicked()">Update Now</button>
        <button mat-flat-button (click)="snoozeClicked()">Snooze (10 minutes)</button>
      </div>
    </div>
  </ng-template>
</p-toast>
